import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import "./MerchantOnboardingStyle";
import MerchantOnboarding from "../../../components/services/merchant/index";
const MerchantOnboardingPage = React.memo((props) => {
  return (
    <>
      <MerchantOnboarding />
    </>
  );
});
export default withRouter(MerchantOnboardingPage);
